// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"426":"fba002b7","787":"4521992f"}[chunkId] + ".chunk.js";
};